// @flow

import React, { useEffect, useState } from 'react'
import Appear from './Appear'
import type { Image as ImageType } from 'types/'
import { markdown } from 'markdown'
import Image from './Image'
import { forEach } from 'async'

type SpeakerType = {
  id: string,
  image: ImageType,
  name: string,
  description: string,
}

type Props = {
  startTime: string,
  text: string,
  description: boolean,
  speaker: Array<SpeakerType>,
  sessionNumber: string,
  schedule: string,
  date: string,
  session: string,
}

const ProgramItemPoint = ({ startTime,
  text,
  description,
  speaker,
  schedule,
  date,
  session,
  sessionNumber }: Props) => {

  const [isLastItem, setIsLastItem] = useState(false)

  useEffect(() => {
    console.log('Program Item Point', text)
  }, [])

  return (
    <>
      <div id={startTime} data-item={startTime} className="px-5 pb-8 text-base md:pl-8 md:pr-24">
        <Appear>
          <span className="block mb-4 font-black text-black">{schedule}: {startTime}.</span>
        </Appear>
        <Appear>
          <div>
            {description && 
              <div className="font-black text-black" dangerouslySetInnerHTML={{ __html: markdown.toHTML(description) }} />
            }
            {text && 
              <div className="text-black" dangerouslySetInnerHTML={{ __html: markdown.toHTML(text) }} />
            }
          </div>
        </Appear>
        {speaker.map(speaker => (
          <div key={speaker.id}>
            {speaker.image.dir !== "" && (
              <Appear>
                <div className="w-40 h-auto mt-8 mb-4 md:my-4">
                  <img src={speaker.image.dir + speaker.image.name.normal + "." + speaker.image.extension} alt={speaker.name} />
                </div>
              </Appear>
            )}
            <Appear>
              <span className="block font-black">{speaker.name}.</span>
            </Appear>
            {speaker.description && 
              <span className="text-black" dangerouslySetInnerHTML={{ __html: markdown.toHTML(speaker.description) }} />
            }
            {console.log(speaker)}
          </div>
        ))}
      </div>
      {!isLastItem &&
        <Appear>
          <div className="mb-8 bg-white border-b-4 border-dashed border-light-gray" />
        </Appear>
      }
    </>
  )
}

export default ProgramItemPoint
